<template>
  <aside id="gnb" style="z-index: 10">
    <ul class="btn">
      <li v-for="(menu, index) in menuList" v-bind:key="index" :class="{'on': selectedTopMenuId === menu.mapSysNo}" >
        <a href="#" @click.prevent="clickTopMenu( menu.mapSysNo )"> {{menu.mapSysNm }}</a>
      </li>
    </ul>
  </aside>
</template>

<script>
import commonUI from '@/mixin/commonUI'
import menuApi from '@/api/web/MenuApi'

export default {
  name: 'BoardMenu',
  mixins: [commonUI],
  data () {
    return {
      menuList: null,
      selectedTopMenuId: '',
    }
  },
  computed: {
  },
  created () {
    this.searchMenu()
  },

  mounted () {

  },

  methods: {
     // 메뉴 조회
    async searchMenu () {
      const searchMenuData = await menuApi.searchMenu()
      this.menuList = searchMenuData

      if (this.menuList.length > 0) {
        this.selectedTopMenuId = this.menuList[0].mapSysNo
      }
    },

    // 메뉴 클릭 이벤트
    clickTopMenu (mapSysNo) {
      this.selectedTopMenuId = mapSysNo

      this.$router.push({
        name: 'portal',
        params: {
          topMenu: mapSysNo
        }
      })

    },
  }
}
</script>

<style scoped>

</style>
